import { post } from "@shared/utils/server";

export const updateBalance = async ({ amount }: { amount: number }) => {
  return await post({
    method: "Ss.updateBalance",
    args: {
      amount,
    },
  });
};
